import styled from 'styled-components';

export const PartnerApiDocsPreStyled = styled.pre`
    padding: 16px;
    border-radius: 8px;
    background-color: #212529;
    white-space: break-spaces;
`;
